__turbopack_context__.v({
  "container": "DrawCounter-module__8IJgvW__container",
  "countdown": "DrawCounter-module__8IJgvW__countdown",
  "edition2026": "DrawCounter-module__8IJgvW__edition2026",
  "label": "DrawCounter-module__8IJgvW__label",
  "nextDraw": "DrawCounter-module__8IJgvW__nextDraw",
  "number": "DrawCounter-module__8IJgvW__number",
  "separator": "DrawCounter-module__8IJgvW__separator",
  "timeBlock": "DrawCounter-module__8IJgvW__timeBlock",
});
